import { Tool } from './Tool'
import { Vector } from './Vector';

export class PathTool extends Tool {
	constructor() {
		super({
			mode: 'path',
			name: '路径工具',
			className: 'brush',
		});
	}

	onActived() {
		this.path = null;
	}

	onInput({ type, x, y }) {
		let commit = false;
		switch (type) {
			case 'mousedown':
				this.path = {
					type: 'path',
					param: [[x, y]]
				};
				break;
			case 'mousemove':
				if (this.path) {
					this.path.param.push([x, y]);
				}
				break;
			case 'mouseup':
				commit = true;
				break;
		}
		const output = { commit, drawing: this.path };
		if (commit) {
			this.path = null;
		}
		return output;
	}

	onDeactived() {
		this.path = null;
		return super.onDeactived();
	}

	onRenderCanvas(ctx, drawing) {
		const { param, brushColor, brushWidth } = drawing;
		const [p0, ...otherPoints] = param;
		ctx.save();
		ctx.strokeStyle = brushColor;
		ctx.lineWidth = brushWidth;
		ctx.beginPath();
		ctx.moveTo(...p0);
		for (let p of otherPoints) {
			ctx.lineTo(...p);
		}
		ctx.stroke();
		ctx.restore();
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/PathTool.js